import { AuthProvider, AuthProviderType, AuthOptions } from "./authProviderInterface";
import { CognitoAuthProvider } from "./cognitoAuthProvider";
import { MsalAuthProvider, MsalAuthOptions } from "./msalAuthProvider";

export class AuthProviderFactory {
    static createProvider(type: AuthProviderType): AuthProvider {
        switch (type) {
            case "Cognito":
                return new CognitoAuthProvider();
            case "MSAL":
            case "OIDC":
                return new MsalAuthProvider();
            default:
                throw new Error(`Unsupported auth provider type: ${type}`);
        }
    }

    static createMsalConfig(type: AuthProviderType, config: any): any {
        switch (type) {
            case "MSAL":
                return {
                    auth: {
                        clientId: config.VITE_APP_ADAL_GRAPHID,
                        authority: `https://login.microsoftonline.com/${config.VITE_APP_ADAL_TENANT}`,
                        redirectUri: window.location.origin,
                    },
                    cache: {
                        cacheLocation: 'localStorage',
                    },
                };
            case "OIDC":
                return this.createOidcConfig(config);
            default:
                throw new Error(`Unsupported MSAL config type: ${type}`);
        }
    }

    static createOidcConfig(config: any): any {
        // Generic OIDC configuration - reads from environment variables
        const authority = config.VITE_APP_OIDC_AUTHORITY;
        const clientId = config.VITE_APP_OIDC_CLIENT_ID;
        const scopes = config.VITE_APP_OIDC_SCOPES ? config.VITE_APP_OIDC_SCOPES.split(',') : ["openid"];
        const knownAuthorities = config.VITE_APP_OIDC_KNOWN_AUTHORITIES ?
            config.VITE_APP_OIDC_KNOWN_AUTHORITIES.split(',') : [authority];

        if (!authority || !clientId) {
            throw new Error('OIDC configuration missing. Please set VITE_APP_OIDC_AUTHORITY and VITE_APP_OIDC_CLIENT_ID');
        }

        return {
            auth: {
                clientId: clientId,
                authority: authority,
                knownAuthorities: knownAuthorities,
                protocolMode: "OIDC",
                //redirectUri: window.location.origin,
            },
            cache: {
                cacheLocation: 'localStorage',
            },
            request: {
                scopes: scopes,
                prompt: config.VITE_APP_OIDC_PROMPT || "login"
            }
        };
    }

    static getAuthProviderType(config: any): AuthProviderType {
        // Check for explicit auth provider setting
        if (config.VITE_APP_AUTH_PROVIDER) {
            const provider = config.VITE_APP_AUTH_PROVIDER.toUpperCase();
            switch(provider) {
                case "MSAL":
                    return "MSAL";
                case "COGNITO":
                    return "Cognito";
                case "OIDC":
                    return "OIDC";
                default:
                    console.warn(`Invalid auth provider: ${config.VITE_APP_AUTH_PROVIDER}, defaulting to MSAL`);
                    return "MSAL";
            }
        }

        // Fallback to legacy Cognito check
        if (config.VITE_APP_USE_COGNITO === "true" || config.VITE_APP_USE_COGNITO === true) {
            return "Cognito";
        }

        // Default to MSAL for backward compatibility
        return "MSAL";
    }
}